import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/apiEnvelope';

/**
 * POST /api/auth/login
 * Expects envelope { success, data: { token, user?, ... } } — shape may vary by backend version.
 *
 * @param {{ username: string; password: string } | { email?: string; password: string }} credentials
 */
export async function login(credentials) {
  const response = await axiosClient.post('/api/auth/login', credentials);
  const data = unwrapApiResponse(response);

  const role =
    data?.user?.role ?? data?.role ?? data?.User?.role;
  if (role != null && String(role) !== 'Admin') {
    throw new Error('Only administrators can access the CMS.');
  }

  return data;
}
